var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHfaDonutOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 149.874 149.874",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2323"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_469_40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.874 74.9371C149.874 116.324 116.324 149.874 74.9371 149.874C33.5505 149.874 0 116.324 0 74.9371C0 33.5505 33.5505 0 74.9371 0C116.324 0 149.874 33.5505 149.874 74.9371ZM10.0994 74.9371C10.0994 110.746 39.1283 139.775 74.9371 139.775C110.746 139.775 139.775 110.746 139.775 74.9371C139.775 39.1283 110.746 10.0994 74.9371 10.0994C39.1283 10.0994 10.0994 39.1283 10.0994 74.9371Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.874 74.9371C149.874 116.324 116.324 149.874 74.9371 149.874C33.5505 149.874 0 116.324 0 74.9371C0 33.5505 33.5505 0 74.9371 0C116.324 0 149.874 33.5505 149.874 74.9371ZM10.0994 74.9371C10.0994 110.746 39.1283 139.775 74.9371 139.775C110.746 139.775 139.775 110.746 139.775 74.9371C139.775 39.1283 110.746 10.0994 74.9371 10.0994C39.1283 10.0994 10.0994 39.1283 10.0994 74.9371Z",
    fill: "var(--fill-0, #F0F0F0)",
    stroke: "var(--stroke-0, #F0F0F0)",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_469_40)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfaDonutOuter);
export default __webpack_public_path__ + "static/media/hfa_donut_outer.d3c881e2684f24de5634248359f90888.svg";
export { ForwardRef as ReactComponent };